import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as tokens from '@tokens';

export interface BaseActionProps {
  /**
   * Accessible description of the action, visible only to screen readers.
   */
  description: string;
  /**
   * Styles override.
   */
  className?: string;
}

export const ActionBaseStyles = css`
  cursor: pointer;
  width: ${tokens.spacer.x3};
  height: ${tokens.spacer.x3};
  padding: 0;
  ${tokens.flexCenter()}
  background: none;
  border: none;
  border-radius: ${tokens.radius.m};

  &:focus {
    outline: none;
    ${tokens.focus()};
  }
  flex-shrink: 0;
`;

export const ActionButtonContainer = styled.button`
  ${ActionBaseStyles};
  color: ${tokens.color.text_light};
  &:hover {
    color: ${tokens.color.text_default};
  }
`;
